// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#loadingPart[data-v-1de1da25]{position:fixed;top:0;left:0;width:100vw;height:calc(var(--vh)*100);z-index:10001;background:hsla(0,0%,100%,.5098);display:table}#loadingPart .message[data-v-1de1da25]{display:table-cell;vertical-align:middle;text-align:center}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
